export interface IGridConfig {
  keyExpr: string;
  sortingEnabled?: boolean;
  gridActionsEnabled?: boolean;
  hideEmptyColumns?: boolean;
  subGridEnabled?: boolean;
  subGridDataSourceKey?: string;
  subGridConfigKey?: string;
  subGridColumnsKey?: string;
  batchActions?: boolean;
}
